import { useState } from 'react'

interface UseConfirmDialogOptions {
  title: string
  description: string
  confirmText?: string
  cancelText?: string
  variant?: 'default' | 'destructive'
}

export function useConfirmDialog() {
  const [isOpen, setIsOpen] = useState(false)
  const [options, setOptions] = useState<UseConfirmDialogOptions>({
    title: '',
    description: '',
    confirmText: 'Bestätigen',
    cancelText: 'Abbrechen',
    variant: 'default',
  })
  const [onConfirmCallback, setOnConfirmCallback] = useState<(() => void) | null>(null)

  const confirm = (opts: UseConfirmDialogOptions, onConfirm: () => void) => {
    setOptions({
      ...opts,
      confirmText: opts.confirmText || 'Bestätigen',
      cancelText: opts.cancelText || 'Abbrechen',
      variant: opts.variant || 'default',
    })
    setOnConfirmCallback(() => onConfirm)
    setIsOpen(true)
  }

  const handleConfirm = () => {
    if (onConfirmCallback) {
      onConfirmCallback()
    }
    setIsOpen(false)
  }

  const handleCancel = () => {
    setIsOpen(false)
  }

  return {
    isOpen,
    options,
    confirm,
    handleConfirm,
    handleCancel,
    setIsOpen,
  }
}
